module.exports = __webpack_public_path__ + "static/media/Lensa Anak Terminal.37f88380.png";